import { ConfigurationAutomaticAssignmentAlgorithmResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.dto'

export enum ConfigurationAutomationPersonnelAlgorithmsDefinitionModalTabIndex {
    BASIC = 0,
    STEPS = 1
}

export interface ConfigurationAutomationPersonnelAlgorithmsDefinitionModalState {
    automaticAssignmentAlgorithm: Partial<ConfigurationAutomaticAssignmentAlgorithmResponse>
    activeTabIndex: number
}
export const initialConfigurationAutomationPersonnelAlgorithmsDefinitionModalState =
    (): ConfigurationAutomationPersonnelAlgorithmsDefinitionModalState => ({
        automaticAssignmentAlgorithm: {},
        activeTabIndex: ConfigurationAutomationPersonnelAlgorithmsDefinitionModalTabIndex.BASIC
    })
